import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router";
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Pagination,
    PaginationItem,
    PaginationLink,
} from "reactstrap";
import {
    CREATE_TEMPLATE_ROUTE,
    GET_ALL_TEMPLATES_URL,
    ITEMS_PER_PAGE_LIST,
    LOGIN_ROUTE,
} from "../../constants";
import {
    addAllTemplates,
    removeAllTemplates,
} from "../../redux/template/templateActions";
import ProjectNavbar from "../widgets/projectNavbar";
import ProjectTable from "../widgets/projectTable";
import { Link } from "react-router-dom";

const Templates = () => {
    const jwt = useSelector((state) => state.authReducer.jwt);
    const currentUser = useSelector((state) => state.authReducer.currentUser);

    const templates = useSelector((state) => state.templateReducer.templates);
    const dispatch = useDispatch();

    const [perPage, setPerPage] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);

    async function fetchTemplates() {
        const response = await axios(
            GET_ALL_TEMPLATES_URL + `?per_page=${perPage}&page=${pageNumber}`,
            {
                headers: { Authorization: `Bearer ${jwt}` },
            }
        );

        let templatesList = [];
        response.data.templates.data.forEach((template) => {
            templatesList.push(template);
        });
        setTotalItems(response.data.templates.total);

        dispatch(addAllTemplates(templatesList));
    }
    useEffect(() => {
        fetchTemplates();
        return () => {
            dispatch(removeAllTemplates());
        };
    }, [dispatch, perPage, pageNumber]);

    function handleItemsPerPageChange(e, newPerPage) {
        e.preventDefault();

        setPerPage(newPerPage);
        setPageNumber(1);
    }

    var paginationLinks = [];
    for (var i = 1; i <= Math.ceil(totalItems / perPage); i++) {
        paginationLinks.push(i);
    }

    return (
        <>
            {jwt === null ? (
                // if the user is not logged in then redirect to login
                <Redirect to={LOGIN_ROUTE} />
            ) : (
                <div className="container-lg">
                    <ProjectNavbar />
                    <div className="container-fluid">
                        <div className="page-header">
                            <h1 className="d-inline">Templates</h1>
                            {currentUser.role !== "USER" ? (
                                <Link
                                    to={CREATE_TEMPLATE_ROUTE}
                                    className="btn btn-outline-success float-end"
                                >
                                    Create Template
                                </Link>
                            ) : null}
                        </div>
                        <hr />
                        <div className="my-4">
                            Show
                            <Dropdown
                                isOpen={dropdownOpen}
                                toggle={toggle}
                                className="d-inline mx-2"
                            >
                                <DropdownToggle caret>{perPage}</DropdownToggle>
                                <DropdownMenu>
                                    {ITEMS_PER_PAGE_LIST.map((itemPerPage) => {
                                        return (
                                            <DropdownItem
                                                key={itemPerPage}
                                                onClick={(e) =>
                                                    handleItemsPerPageChange(
                                                        e,
                                                        itemPerPage
                                                    )
                                                }
                                            >
                                                {itemPerPage}
                                            </DropdownItem>
                                        );
                                    })}
                                </DropdownMenu>
                            </Dropdown>
                            entries
                        </div>
                        <ProjectTable data={templates} type="TEMPLATES" />
                        <Pagination
                            aria-label="Page navigation example"
                            className="justify-content-center"
                        >
                            {paginationLinks.map((paginationLink) => (
                                <PaginationItem
                                    key={paginationLink}
                                    active={pageNumber === paginationLink}
                                >
                                    <PaginationLink
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (pageNumber !== paginationLink)
                                                setPageNumber(paginationLink);
                                        }}
                                    >
                                        {paginationLink}
                                    </PaginationLink>
                                </PaginationItem>
                            ))}
                        </Pagination>
                    </div>
                </div>
            )}
        </>
    );
};

export default Templates;
